import { useBranchLogo } from '@/entities/Branch';
import {
  buildModalPrintDocument,
  buildPrintHeaderHtml,
  collectPrintStyles,
  ensurePrintSvgViewBox,
  waitForPrintAssets,
  buildQualityRecordHeaderPrintStyleOverrides,
} from '@/shared/lib/print';
import { buildTrainingRecordPrintStyleOverrides } from '../lib/buildTrainingRecordPrintStyleOverrides';

export const TRAINING_MATRIX_REPORT_CONTENT_ID = 'training-matrix-report-content';

export const useTrainingMatrixReportPrint = () => {
  const { resolvePrintableLogoSrc } = useBranchLogo();

  const printTrainingMatrixReport = async () => {
    const printContent = document.getElementById(TRAINING_MATRIX_REPORT_CONTENT_ID);
    if (!printContent) return;

    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    const [headerElement, ...bodyElements] = Array.from(printContent.children);
    const headerHtml = buildPrintHeaderHtml(headerElement, await resolvePrintableLogoSrc());
    const bodyHtml = bodyElements.map((element) => element.outerHTML).join('');

    printWindow.document.write(
      buildModalPrintDocument({
        title: 'Matriz de Treinamentos',
        headerHtml,
        bodyHtml,
        styles: `${collectPrintStyles()}\n${buildTrainingRecordPrintStyleOverrides()}\n${buildQualityRecordHeaderPrintStyleOverrides()}`,
        repeatHeaderOnEveryPage: true,
      })
    );
    printWindow.document.close();
    ensurePrintSvgViewBox(printWindow);
    await waitForPrintAssets(printWindow);
    printWindow.print();
  };

  return {
    printTrainingMatrixReport,
  };
};
